import { useState } from "react";

const DeleteAccount = () => {
  const [email, setEmail] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email) {
      alert("Please enter your email.");
      return;
    }
    alert(`Deletion request sent for ${email}`);
  };

  return (
    <div className="bg-[#e1d5ee] flex items-center justify-center min-h-screen p-10">
      <div className="bg-white p-6 rounded-lg shadow-lg w-96">
        <h2 className="text-xl font-semibold mb-4">Delete Account</h2>
        <p className="text-gray-600 mb-4">
          Enter your email to request account deletion.
        </p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#64308E]"
            required
          />
          <button
            type="submit"
            className="w-full bg-[#64308E] text-white py-2 rounded-lg transition transform ease-in-out hover:-translate-y-1"
          >
            Submit Request
          </button>
        </form>
      </div>
    </div>
  );
};

export default DeleteAccount;
